var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H5.83333",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 2.5H15.8332C16.2752 2.5 16.6991 2.67559 17.0117 2.98816C17.3242 3.30072 17.4998 3.72464 17.4998 4.16667V5.83333",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 14.166V15.8327C17.4998 16.2747 17.3242 16.6986 17.0117 17.0112C16.6991 17.3238 16.2752 17.4993 15.8332 17.4993H14.1665",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 17.4993H4.16667C3.72464 17.4993 3.30072 17.3238 2.98816 17.0112C2.67559 16.6986 2.5 16.2747 2.5 15.8327V14.166",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 10.8327C10.4601 10.8327 10.8332 10.4596 10.8332 9.99935C10.8332 9.53911 10.4601 9.16602 9.99984 9.16602C9.5396 9.16602 9.1665 9.53911 9.1665 9.99935C9.1665 10.4596 9.5396 10.8327 9.99984 10.8327Z",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7865 9.72437C15.8488 9.90242 15.8488 10.0963 15.7865 10.2744C15.3173 11.424 14.5164 12.4079 13.4857 13.1004C12.4551 13.7929 11.2415 14.1628 9.99985 14.1628C8.75816 14.1628 7.5446 13.7929 6.51397 13.1004C5.48335 12.4079 4.68236 11.424 4.21319 10.2744C4.15094 10.0963 4.15094 9.90242 4.21319 9.72437C4.68236 8.57473 5.48335 7.59089 6.51397 6.89834C7.5446 6.2058 8.75816 5.83594 9.99985 5.83594C11.2415 5.83594 12.4551 6.2058 13.4857 6.89834C14.5164 7.59089 15.3173 8.57473 15.7865 9.72437Z",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanEye);
export default __webpack_public_path__ + "static/media/scan-eye.97278bd766b4c307ee1629ad9fd2d47a.svg";
export { ForwardRef as ReactComponent };